import { createAsyncThunk } from '@reduxjs/toolkit';
import { IThunkApi } from '../../types/redux';
import { setErrorMessage, setRedirectUrl } from '../../slices';
import { fetchNewbuildingData } from './fetchNewbuildingData';
import { IApplicationContext } from '../../types/applicationContext';
import { selectSource, selectNewbuildingFormValues, selectFormFields } from '../../selectors';
import { useGetTrackAddMyHomeObject } from 'shared/mf-my-home/hooks';
import { EMyHomeEstimationTargets } from 'shared/mf-my-home/types/estimationTarget';

export const submitNewbuildingData = createAsyncThunk<void, undefined, IThunkApi>(
  'form/submitNewbuildingData',
  async (_, _thunkApi) => {
    const { extra, getState, dispatch } = _thunkApi;
    const state = getState();

    const source = selectSource(state);
    const { newBuildingId, newbuildingHouse, area, newBuildingHouseId, roomsCount } =
      selectNewbuildingFormValues(state);
    const filters = selectFormFields(state);

    const trackMyHomeAddObjectSuccess = useGetTrackAddMyHomeObject({
      estimationTarget: EMyHomeEstimationTargets.flat,
      filters,
      isSubmit: true,
      isNewbuilding: true,
    });

    const parameters = {
      newBuildingId,
      newbuildingHouse,
      area,
      newBuildingHouseId,
      roomsCount,
      source,
      isNeedChatSubscribe: false,
      isNeedPushSubscribe: false,
    };

    try {
      const res = await fetchNewbuildingData(parameters, extra as IApplicationContext);

      trackMyHomeAddObjectSuccess();

      dispatch(setRedirectUrl(res));
    } catch (error) {
      dispatch(setErrorMessage(error.message));
    }
  },
);
